export enum Route {
  REPORTING_DASHBOARD = '/reporting',
  REPORTING_V2 = '/reporting-v2',
  CUSTOM_DASHBOARDS = '/custom-dashboards',
  /** A single dashboard. Its identity lives in the URL so it can be bookmarked,
   *  linked, and survive a refresh (and so Share has something to point at). */
  CUSTOM_DASHBOARD_DETAIL = '/custom-dashboards/:dashboardId',
  FORECASTER = '/forecaster',
  FORECASTER_TABLE = '/forecaster-table',
  FORECASTER_AI = '/forecaster-ai',
  USER_MANAGEMENT = '/usermanagement',
  CAMPAIGN_SUBMISSION = '/campaigns',
  CAMPAIGN_MANAGEMENT = '/campaign-management',
  CREATE_CAMPAIGN = '/campaign-management/:idType?/:campaignId',
  SETTINGS = '/settings',
  PACING = '/pacing',
  REPORT_BUILDER = '/report-builder',
  PDF_BUILDER = '/pdf-builder',
  CREATIVE_LIBRARY = '/creative-library',
  PIXELS = '/pixels',
  WHITELABELS = '/whitelabels',
  ADVERTISERS = '/advertisers',
  AGENCIES = '/agencies',
  LOGIN = '/',
  FORGOT_PASSWORD = '/forgot-password',
  SET_NEW_PASSWORD = '/set-new-password/:token',
  FIRST_PARTY_DATA = '/first-party-data',
  CHANGE_LOG_HISTORY = '/change-log-history',
  CLIENTS = '/clients',
  INSIGHTS = '/insights',
  SEGMENTS = '/segments',
  PARTNER_DATA_HEALTH = '/partner-data-health',
  SSO = '/sso/:token',
}

export default Route;
